import React, { useState, useRef, useEffect } from 'react';
import { PiBoatLight } from "react-icons/pi";
import { GrClose } from "react-icons/gr";
import "./SearchBarStyle.css"; // Reuse existing styles or new ones

const BoatTypeSelect = ({
    options,
    selectedOptions,
    setSelectedOptions,
    placeholder = "By Type" // Default value
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            // If the dropdown is open and the click is outside the dropdown ref
            if (isOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedOptions(options);
        } else {
            setSelectedOptions([]);
        }
    };

    const handleOptionChange = (option, isChecked) => {
        if (isChecked) {
            setSelectedOptions(prev => [...prev, option]);
        } else {
            setSelectedOptions(prev => prev.filter(o => o.value !== option.value));
        }
    };

    const isAllSelected = options.length > 0 && selectedOptions.length === options.length;

    return (
        <div className="search-field-wrapper" ref={dropdownRef}>
            <PiBoatLight className="search-icon" />
            <div className="custom-select-container">
                <div
                    className="custom-select-trigger"
                    onClick={toggleDropdown}
                >
                    {selectedOptions.length === 0 ? (
                        <span className="placeholder-text">{placeholder}</span>
                    ) : (
                        <span className="selected-text">
                            {selectedOptions.map(o => o.label).join(", ")}
                        </span>
                    )}
                </div>

                {isOpen && (
                    <div className="custom-dropdown-menu">
                        <div className="custom-dropdown-header">
                            <span className="dropdown-label">{placeholder}</span>
                            <GrClose
                                className="close-icon"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsOpen(false);
                                }}
                            />
                        </div>

                        <div className="custom-dropdown-options">
                            {/* Select All Option */}
                            <label className="custom-option-item select-all-option">
                                <input
                                    type="checkbox"
                                    checked={isAllSelected}
                                    onChange={handleSelectAll}
                                />
                                <span>Select all</span>
                            </label>

                            {/* Individual Options */}
                            {options.map((option, index) => {
                                const isSelected = selectedOptions.some(item => item.value === option.value);
                                return (
                                    <label key={option.value} className="custom-option-item">
                                        <input
                                            type="checkbox"
                                            checked={isSelected}
                                            onChange={(e) => handleOptionChange(option, e.target.checked)}
                                        />
                                        <span>{option.label}</span>
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BoatTypeSelect;
